import { ExternalLinks } from "@components/external-links";
import { Alert, Text } from "@flat-ui";
import { runtimeConfig } from "@src/runtime-config";
import { AppRegion } from "@src/runtime-config-types";

/** Name to display for the ACC account for each region */
const ACCOUNT_NAME: Record<AppRegion, string> = {
  com: "ACC account",
  eu: "ACC EU account",
};

/** Account name */
const accountName = ACCOUNT_NAME[runtimeConfig.appRegion];

/** App name to look for in the ACC App Gallery for each region */
const APP_NAME: Record<AppRegion, string> = {
  com: "FARO Sphere® XG/HoloBuilder",
  eu: "FARO Sphere® XG/HoloBuilder EU",
};

/** App name */
const appName = APP_NAME[runtimeConfig.appRegion];

/** Information on how to install the Sphere XG app in an ACC account */
export function ConnectDialogAutodeskHint(): JSX.Element {
  return (
    <Alert
      title={`You don't see your ${accountName} listed below?`}
      variant="info"
      isCollapsible
      description={(
        <>
          <Text
            component="div"
            variant="bodyM"
          >
            If your {accountName} is missing from the list of hubs,
            it may be because the Sphere XG app is not installed in your {accountName}.
            Look for the app named "{appName}" in the ACC App Gallery.
            {" "}
            <ExternalLinks
              text="See this article"
              link="autodeskAppStoreArticle"
            />
            {" "}
            to learn how to install it.
          </Text>
          <Text
            component="div"
            variant="bodyM"
            sx={{ marginTop: "8px" }}
          >
            <ExternalLinks
              text="Learn more"
              link="sphereXGAccIntegration"
            />
            {" about the ACC integration with Sphere XG."}
          </Text>
        </>
      )}
      sx={{
        mb: "8px",
      }}
    />
  );
}
